export default __webpack_public_path__ + "static/media/hhinvite.325352a2.jpg";